// extracted by mini-css-extract-plugin
export default {"recent-activites":"RecentActivities_recent-activites__8I1yD","header":"RecentActivities_header__7etoP","body":"RecentActivities_body__7lxob"};